export default __webpack_public_path__ + "static/media/more-active-icon.333a39bc.svg";